import { asyncOperation, clientRepo, useCollectionBind, useUser } from "@zickko/client";
import { EmailKey, firestorePaths, OutboundEmail } from "@zickko/shared";
import { useOrg } from "../providers/OrgProvider";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { OutboundEmailListWidget } from "../widgets/email/OutboundEmailListWidget";
import { OutboundEmailViewWidget } from "../widgets/email/OutboundEmailViewWidget";
import { TrashEmail } from "@zickko/shared/src/models/TrashEmail";
import toast from "react-hot-toast";
import { Clock3, CornerUpLeft, CornerUpRight, EllipsisVerticalIcon, ReplyAll, Trash2 } from "lucide-react";

export const OutboxPage = () => {
  const { org } = useOrg();
  const { user } = useUser();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedEmail, setSelectedEmail] = useState<OutboundEmail>();
  const emailId = searchParams.get("emailId");

  const { list: emailList = [] } = useCollectionBind(firestorePaths.outbox, {
    key: {
      orgId: org.id,
      uid: user.uid,
    },
    orderByField: "uid",
    orderByDirection: "desc",
  });

  useEffect(() => {
    if (!selectedEmail && emailList.length > 0) {
      const firstEmail = emailList[0];
      setSearchParams({ emailId: firstEmail.id });
      setSelectedEmail(firstEmail);
    } else if (selectedEmail) {
      setSearchParams({ emailId: selectedEmail.id });
    }
  }, [selectedEmail, emailList, setSearchParams, setSelectedEmail]);

  if (emailList === undefined) {
    return <div>Loading emails...</div>;
  }

  const onDeleteEmail = () => {
    asyncOperation({
      fn: async () => {
        const emailKey: EmailKey = { emailId: emailId, orgId: selectedEmail.orgId, uid: selectedEmail.uid };
        const trashEmail: TrashEmail = {
          emailId: emailId,
          orgId: selectedEmail.orgId,
          uid: selectedEmail.uid,
          email: selectedEmail,
          deletedIsoDateTimeUtc: new Date().toISOString(),
          type: "OutboundEmail",
        };
        await clientRepo.trashEmail.set(emailKey, trashEmail);
        await clientRepo.outboundEmail.remove(emailKey);
      },
      onSuccess: () => {
        toast.success("Email Deleted Successfully");
      },
      onError(e) {
        toast.error("Error in deleting email.");
      },
    });
  };

  return (
    <div className="inbox-page">
      <div className="email-list-widget">
        <div className="email-list-header">
          <div className="inbox-heading">Outbox</div>
          <div className="switch-button">
            <div className={`all-mail`}>All Mail</div>
          </div>
        </div>
        <OutboundEmailListWidget emailList={emailList} onSelectEmail={(email) => setSelectedEmail(email)} />
      </div>
      <div className="email-view-widget">
        <div className="email-action-items">
          <div className="actions">
            <Trash2 onClick={onDeleteEmail} size={18} />
            <div className="vertical-line"> </div>
            <Clock3 size={18} />
          </div>
          <div className="reply-actions">
            <CornerUpLeft size={18} />
            <ReplyAll size={18} />
            <CornerUpRight size={18} />
            <div className="vertical-line"> </div>
            <EllipsisVerticalIcon size={18} />
          </div>
        </div>
        <OutboundEmailViewWidget email={selectedEmail} />
      </div>
    </div>
  );
};
